import { createReducer, Action, on } from '@ngrx/store';
import { State, initialState } from './state';
import * as actions from './actions';

const reducer = createReducer(
  initialState,
  on(actions.getCacheSuccess, ((state, { user })  => {
    return {
      ...state,
      info: {
        loading: false,
        data: user,
        error: null
      }
    };
  })),
  on(actions.login, ((state)  => {
    return {
      ...state,
      info: {
        loading: true,
        data: null,
        error: null
      }
    };
  })),
  on(actions.verifyMfa, ((state)  => {
    return {
      ...state,
      info: {
        loading: true,
        data: null,
        error: null
      }
    };
  })),
  on(actions.loginSuccess, ((state, { user })  => {
    return {
      ...state,
      info: {
        loading: false,
        data: user,
        error: null
      }
    };
  })),
  on(actions.loginFail, ((state, { error })  => {
    return {
      ...state,
      info: {
        loading: false,
        data: null,
        error
      }
    };
  })),
  on(actions.loginResponse, ((state, { response })  => {
    return {
      ...state,
      info: {
        loading: false,
        data: null,
        error: null
      },
      mfa: {
        mfaId: response.mfaId,
        mfaContact: response.mfaContact,
        mfaBySms: response.mfaBySms
      }
    };
  })),
  on(actions.loadBalance, (state => {
    return {
      ...state,
      balance: {
        ...state.balance,
        loading: true
      }
    };
  })),
  on(actions.loadBalanceSuccess, ((state, { userBalance }) => {
    return {
      ...state,
      balance: {
        loading: false,
        data: userBalance,
        error: null
      }
    };
  })),
  on(actions.updateOrganization, ((state, { user }) => {
    return {
      ...state,
      info: {
        ...state.info,
        data: user
      }
    };
  }))
);

export function userReducer(state: State, action: Action) {
  return reducer(state, action);
}
